import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { AuthenticationService } from "src/_services/authentication.service";

@Component({
  selector: "app-log-in",
  templateUrl: "./log-in.component.html",
  styleUrls: ["./log-in.component.scss"],
})
export class LogInComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  hide = false;
  submitted = false;
  returnUrl: string;
  error = "";
  IpAddress: "";
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    if (this.authenticationService.currentUserValue) {
      this.router.navigateByUrl("/login");
    }
  }

  ngOnInit() {
    this.getIp();
    this.loginForm = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });

    // get return url from route parameters or default to '/'
    this.returnUrl =
      this.route.snapshot.queryParams["returnUrl"] ||
      this.router.navigateByUrl("/login");
  }

  get f() {
    return this.loginForm.controls;
  }
  async getIp() {
    const response = await fetch("https://geolocation-db.com/json/");

    // const response = await fetch('https://api.ipify.org?formate=json');
    const data = await response.json();
    this.IpAddress = data.IPv4;
  }

  
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService
      .login(
        this.f.username.value.trim(),
        this.f.password.value,
        this.IpAddress
      )
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data["2faRequired"] === true) {
            this.authenticationService.setPending2faLogin({
              userId: this.f.username.value.trim(),
              password: this.f.password.value,
              IP: this.IpAddress,
            });
            this.router.navigateByUrl("/login/two-factor");
            this.loading = false;
            return;
          }

          this.authenticationService.openSnackBar("Login Successful.");
          this.authenticationService.navigateAfterLogin(data);
        },
        (error) => {
          this.error = error;
          this.authenticationService.openErrorSnackBar(error.error.message);
          this.loading = false;
        }
      );
  }
}
